import * as React from 'react';

import { Box, Typography } from '@mui/material';

interface IFormTitle {
  title: string;
  subtitle: string[];
}

function FormTitle({ title, subtitle }: IFormTitle) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      flexGrow={1}
      marginBottom={1}
      marginLeft={1}
    >
      <Typography variant="h6">{title}</Typography>
      { subtitle.map((text) => <Typography key={text} variant="caption">{text}</Typography>)}
    </Box>
  );
}

export default FormTitle;
